var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 24,
    viewBox: "0 0 11 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04472 7.98855C8.30132 7.98855 7.70138 7.38889 7.70138 6.64584V4.90806C7.70138 3.52624 6.57976 2.40515 5.19729 2.40515C3.81482 2.40515 2.6932 3.52624 2.6932 4.90806V6.64584C2.6932 7.38889 2.09326 7.98855 1.34986 7.98855C0.599938 7.98855 0 7.38889 0 6.64584V1.58388C0 0.710463 0.710796 0 1.58462 0H8.80344C9.67726 0 10.3881 0.710463 10.3881 1.58388V6.64584C10.3881 7.38889 9.78812 7.98855 9.04472 7.98855Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80343 24H1.58462C0.710796 24 0 23.2895 0 22.4161V11.4849C0 10.7419 0.599938 10.1422 1.34334 10.1422C2.08674 10.1422 2.68668 10.7419 2.68668 11.4849V19.2679C2.68668 20.6497 3.8083 21.7708 5.19076 21.7708C6.57323 21.7708 7.69485 20.6497 7.69485 19.2679V11.4849C7.69485 10.7419 8.29479 10.1422 9.03819 10.1422C9.78159 10.1422 10.3815 10.7419 10.3815 11.4849V22.4161C10.3881 23.2895 9.67725 24 8.80343 24Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/brand-logo.9a5af159c1abac8c8b02c2614fc04533.svg";
export { ForwardRef as ReactComponent };